







































import { Component } from 'vue-property-decorator';
import { MswAppTitle }  from '@/shared/msw-app-title';
import UUIFComponents from '@/shared/uuifComponent';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { MswApiService } from '@/shared/msw-api-service';
import { InfoState } from '@/core';
import { SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwSelect, SelectOption } from '@sonicwall/unified-ui-framework/src/shared/sw-select';

const cssPrefix = 'competitiveTradeIn';

@Component({
  components:{
    ...UUIFComponents,
    MswAppTitle,
    SwTextfield,
    SwSelect,
  },
})
export default class CompetitiveTradeIn extends SwExtendedVue {
  cssPrefix = cssPrefix;
  productValue: string = '';
  options: SelectOption[] = [];
  selectValue: string = '';
  apiResponse: any = '';
  serialNumber: any = '';

  getCompetitiveData() {
    this.$store.commit('startLoading');
    MswApiService.promotions.getCompetitiveSurvey()
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'NOK') {
        return this.showMessage('failed', resp.msgDesc);
      }
      this.apiResponse = resp.content.arrCompetitiveSurvey;
      this.makeOptions();
    });
  }

  makeOptions() {
    const options = this.apiResponse[1].arrChoices.map((each: any) => {
      return {
        id: each.choicetext,
        label: each.choicetext,
        value: each.choicetext,
        choiceVal: each.choiceVal,
      };
    });
    this.options = options;
  }

  cancel() {
    this.$router.go(-1);
  }

  confirm() {
    this.handleConfirm();
  }

  handleConfirm() {
    const template = {
      competitiveReplacementDevice: this.productValue,
      // @ts-ignore
      competitiveProductInfo: this.getId()['choiceVal'],
      strUpgradeSerial: this.$route.query.srNo,
      competitiveReplacementSerialnumber: this.serialNumber,
      strUpgradeNo: this.$route.query.upgradeID,
    };
    this.$store.commit('startLoading');
    MswApiService.promotions.submitCompetitiveSurvey(template)
    .then((resp: any) => {
      this.$store.commit('stopLoading');
      if (resp.operationStatus === 'NOK') {
        return this.showMessage('failed', resp.msgDesc);
      }
      this.showMessage('success', resp.msgDesc);
      this.$router.push({ path: 'promotionHistory', query: { data: template.strUpgradeNo } });
    });
  }

  getId() {
    // @ts-ignore
    const item = this.options.find(el => el.label.toLowerCase() === this.selectValue.toLowerCase());
    return item;
  }

  mounted() {
    this.getCompetitiveData();
  }

  showMessage(infoType: string, infoMsg: string) {
    // success and failed
    const message: InfoState = { infoType, infoMsg };
    this.$store.commit('displayMessage', message);
  }
}
